import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cheapcabinpune() {



    const cardData = {

keyword: "Cheap Cabs in Pune",

headingDescription:
    "Rising Cab Service offers Cheap Cabs in Pune with affordable pricing, safe travel, and comfortable rides for daily commuters, families, students, and business travelers. We provide budget-friendly local trips, airport transfers, railway station drops, and outstation cab services across Maharashtra and India. Our fleet includes well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles driven by experienced chauffeurs. With 24/7 availability, transparent fares, and reliable service, Rising Cab Service ensures a cost-effective and hassle-free travel experience in Pune.",

topPlaces: [
    {
        title: "Lonavala",
        description:
            "Lonavala is a popular and budget-friendly weekend getaway near Pune known for scenic hills, waterfalls, and viewpoints like Tiger Point and Bhushi Dam. It is ideal for short and affordable trips."
    },
    {
        title: "Shaniwar Wada",
        description:
            "Shaniwar Wada is a historic fort in Pune built by the Peshwas, known for its grand architecture and evening light and sound show. It is a must-visit heritage site within the city."
    },
    {
        title: "Sinhagad Fort",
        description:
            "Sinhagad Fort is a famous trekking and historical destination near Pune known for its scenic views and Maratha history. It is a low-cost and popular weekend outing spot."
    },
    {
        title: "Khadakwasla Dam",
        description:
            "Khadakwasla Dam is a peaceful and budget-friendly picnic spot near Pune known for its beautiful water views, especially during monsoon season."
    },
    {
        title: "Aga Khan Palace",
        description:
            "Aga Khan Palace is a historic monument associated with India’s freedom struggle and is one of Pune’s key cultural attractions with low entry cost and rich history."
    },
    {
        title: "Pune Okayama Friendship Garden",
        description:
            "Pune Okayama Friendship Garden is a beautifully maintained Japanese-style garden offering peaceful walking paths, greenery, and a relaxing environment at minimal cost."
    },
    {
        title: "Parvati Hill Temple",
        description:
            "Parvati Hill Temple is a spiritual and scenic spot in Pune offering panoramic city views after a short climb, making it a simple and low-budget travel destination."
    },
    {
        title: "Pataleshwar Cave Temple",
        description:
            "Pataleshwar Cave Temple is an ancient rock-cut Shiva temple located in central Pune that can be visited at very low cost and is known for its peaceful atmosphere."
    },
    {
        title: "Pashan Lake",
        description:
            "Pashan Lake is a calm and natural birdwatching spot in Pune ideal for morning walks, photography, and relaxation without any high expenses."
    },
    {
        title: "Empress Garden",
        description:
            "Empress Garden is a well-maintained botanical garden in Pune offering greenery, flowers, and walking spaces, making it a budget-friendly family outing destination."
    }
],



services: [
    {
        name: "Cheap Cabs in Pune",
        description:
            "Rising Cab Service offers Cheap Cabs in Pune for budget-friendly travel without compromising safety or comfort. Our services include local rides, airport transfers, and outstation trips with well-maintained vehicles and professional drivers. We ensure transparent pricing, no hidden charges, and reliable service, making it ideal for students, daily commuters, and families looking for economical transportation across Pune."
    },
    {
        name: "Budget Cab Pune",
        description:
            "Our Budget Cab Pune service is designed for cost-effective travel across the city and nearby destinations. Rising Cab Service provides affordable pricing options with multiple vehicle choices including hatchbacks, sedans, and SUVs. Whether it is daily commuting or occasional travel, we ensure smooth rides with safe drivers and on-time pickups."
    },
    {
        name: "Low Cost Cab Pune",
        description:
            "Rising Cab Service offers Low Cost Cab Pune solutions for passengers who want affordable travel without compromising reliability. We provide transparent fare structure, clean vehicles, and experienced drivers for local, airport, and outstation journeys across Maharashtra."
    },
    {
        name: "Affordable Cab Service Pune",
        description:
            "Book Affordable Cab Service Pune with Rising Cab Service for economical travel options across all routes. We offer competitive pricing, flexible booking, and safe transportation for daily rides, airport transfers, and long-distance journeys."
    },
    {
        name: "Cheapest Taxi Pune",
        description:
            "Our Cheapest Taxi Pune service ensures minimum fare travel with maximum safety and comfort. Rising Cab Service focuses on budget-friendly rides with professional drivers and well-maintained vehicles suitable for all travel needs."
    },
    {
        name: "Discount Cab Pune",
        description:
            "Rising Cab Service provides Discount Cab Pune offers for regular customers, seasonal promotions, and long-distance bookings. Enjoy reduced fares with the same premium service quality, safe driving, and comfortable vehicles."
    },
    {
        name: "Economy Cab Pune",
        description:
            "Our Economy Cab Pune service is ideal for daily commuters and budget travelers looking for affordable yet reliable transportation. We ensure clean vehicles, trained drivers, and efficient routes for cost-saving travel."
    },
    {
        name: "Low Fare Taxi Pune",
        description:
            "Rising Cab Service offers Low Fare Taxi Pune options with transparent pricing and no hidden charges. Perfect for short city trips, office travel, and airport transfers at economical rates."
    },
    {
        name: "Cheap Outstation Cab Pune",
        description:
            "Book Cheap Outstation Cab Pune for long-distance travel to cities like Mumbai, Goa, Nashik, Shirdi, and more at budget-friendly rates. We provide safe highway driving and comfortable vehicles for economical intercity journeys."
    },
    {
        name: "Budget Taxi Pune",
        description:
            "Our Budget Taxi Pune service ensures affordable transportation for all types of travel including local rides and outstation trips. Rising Cab Service focuses on cost efficiency without compromising passenger comfort and safety."
    },
    {
        name: "Best Price Cab Pune",
        description:
            "Rising Cab Service offers Best Price Cab Pune with competitive fares and flexible vehicle options. We ensure value-for-money travel with reliable service and transparent pricing for every ride."
    },
    {
        name: "Cab Offers Pune",
        description:
            "Our Cab Offers Pune include seasonal discounts, promo deals, and special pricing for frequent travelers and long-distance bookings, helping customers save more on every ride."
    },
    {
        name: "Economical Cab Pune",
        description:
            "Rising Cab Service provides Economical Cab Pune solutions for cost-conscious travelers with safe, comfortable, and affordable rides across the city and outstation routes."
    },
    {
        name: "Cab Deals Pune",
        description:
            "Book Cab Deals Pune with Rising Cab Service to enjoy discounted fares on local, airport, and outstation trips. We offer attractive pricing without compromising service quality."
    },
    {
        name: "Affordable Outstation Cab Pune",
        description:
            "Our Affordable Outstation Cab Pune service is perfect for long-distance travel at budget-friendly rates with experienced drivers and comfortable vehicles ensuring safe highway journeys."
    },
    {
        name: "Cheap Cab Service in Pune",
        description:
            "Rising Cab Service provides Cheap Cab Service in Pune with reliable transportation, low fares, and professional drivers for all travel needs including city rides and intercity trips."
    },
    {
        name: "Cheap Cab Service Pune",
        description:
            "Our Cheap Cab Service Pune ensures economical travel solutions with clean vehicles, transparent pricing, and safe rides for daily commuting and outstation journeys."
    },
    {
        name: "Pune to Mumbai Cheap Cabs",
        description:
            "Rising Cab Service offers Pune to Mumbai Cheap Cabs for affordable intercity travel with safe highway driving, experienced chauffeurs, and flexible one-way and round-trip options."
    },
    {
        name: "Cheapest Cab Service in Pimpri Chinchwad",
        description:
            "Our Cheapest Cab Service in Pimpri Chinchwad provides low-cost transportation with reliable drivers and well-maintained vehicles for local and outstation travel needs."
    },
    {
        name: "Low Price Taxi Service Pimpri Chinchwad",
        description:
            "Rising Cab Service offers Low Price Taxi Service Pimpri Chinchwad for budget-friendly rides with transparent fares, safe driving, and quick booking options."
    },
    {
        name: "Budget Cab Booking Pune",
        description:
            "Book Budget Cab Booking Pune with Rising Cab Service for affordable travel solutions with instant confirmation, multiple vehicle options, and reliable service."
    },
    {
        name: "Cheap Outstation Cab Pune",
        description:
            "Our Cheap Outstation Cab Pune service provides economical long-distance travel to major destinations with safe drivers and comfortable vehicles ensuring smooth journeys."
    },
    {
        name: "Affordable Taxi Service PCMC",
        description:
            "Rising Cab Service offers Affordable Taxi Service PCMC for Pimpri Chinchwad and surrounding areas with low fares, reliable drivers, and convenient booking options."
    }
],

tableData: [
    ["Cheap Cabs in Pune", "Budget Cab Pune"],
    ["Low Cost Cab Pune", "Affordable Cab Service Pune"],
    ["Cheapest Taxi Pune", "Discount Cab Pune"],
    ["Economy Cab Pune", "Low Fare Taxi Pune"],
    ["Cheap Outstation Cab Pune", "Budget Taxi Pune"],
    ["Best Price Cab Pune", "Cab Offers Pune"],
    ["Economical Cab Pune", "Cab Deals Pune"],
    ["Affordable Outstation Cab Pune", "Cheap Cab Service in Pune"],
    ["Cheap Cab Service Pune", "Pune to Mumbai Cheap Cabs"],
    ["Cheapest Cab Service in Pimpri Chinchwad", "Low Price Taxi Service Pimpri Chinchwad"],
    ["Budget Cab Booking Pune", "Cheap Outstation Cab Pune"],
    ["Affordable Taxi Service PCMC", "Cheap Cab Service Pune"]
],




whychoose: [
    {
        WhyChooseheading: "Budget-Friendly Cab Services Across Pune",
        WhyChoosedescription: "Rising Cab Service offers economical travel options for local rides, airport transfers, railway station pickups, outstation journeys, and daily transportation requirements."
    },
    {
        WhyChooseheading: "Affordable Travel Without Compromising Comfort",
        WhyChoosedescription: "Passengers can enjoy clean, comfortable, and well-maintained vehicles at competitive rates suitable for both short and long-distance travel."
    },
    {
        WhyChooseheading: "Multiple Vehicle Options to Match Your Budget",
        WhyChoosedescription: "From Sedan cars and hatchbacks to Ertiga, Innova Crysta, and Tempo Travellers, customers can choose vehicles according to their travel needs and budget."
    },
    {
        WhyChooseheading: "Smart Choice for Daily Commuters",
        WhyChoosedescription: "Students, office employees, business professionals, and regular travelers prefer our economical cab services for convenient daily transportation."
    },
    {
        WhyChooseheading: "Cost-Effective Airport and Station Transfers",
        WhyChoosedescription: "Our affordable taxi services provide timely transportation to Pune Airport, Pune Railway Station, Shivajinagar Station, and major transit points."
    },
    {
        WhyChooseheading: "Available Throughout Pune and PCMC",
        WhyChoosedescription: "We provide pickup and drop facilities across Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, and Pimpri Chinchwad."
    },
    {
        WhyChooseheading: "Flexible Travel Packages",
        WhyChoosedescription: "Customers can book one-way rides, round trips, hourly rentals, full-day packages, and customized travel plans at affordable rates."
    },
    {
        WhyChooseheading: "Value-Oriented Service Experience",
        WhyChoosedescription: "Rising Cab Service focuses on delivering reliable transportation, professional drivers, and customer satisfaction while keeping travel costs reasonable."
    }
]
};

const faqData = [
    {
        question: "How can travelers find affordable cabs in Pune?",
        answer: "Choosing advance bookings, suitable vehicle categories, and customized travel plans can help travelers access economical cab services."
    },
    {
        question: "Are low-cost airport transfers available in Pune?",
        answer: "Yes, affordable airport pickup and drop services are available from all major areas of Pune and PCMC."
    },
    {
        question: "Which vehicle category is usually the most economical?",
        answer: "Sedan cars are often preferred by budget-conscious travelers due to their comfort and cost-effectiveness."
    },
    {
        question: "Can customers book affordable outstation cabs from Pune?",
        answer: "Yes, budget-friendly outstation taxi services are available for destinations across Maharashtra and nearby states."
    },
    {
        question: "Do affordable cab services include AC vehicles?",
        answer: "Yes, customers can enjoy air-conditioned travel even while selecting economical cab options."
    },
    {
        question: "Is daily office transportation available at reasonable rates?",
        answer: "Yes, many professionals use affordable cab services for regular commuting within Pune and surrounding areas."
    },
    {
        question: "Can families book economical vehicles for sightseeing trips?",
        answer: "Yes, cost-effective travel packages are available for family outings, city tours, and weekend getaways."
    },
    {
        question: "Are one-way travel options available for budget travelers?",
        answer: "Yes, one-way rides help many customers reduce travel expenses while enjoying convenient transportation."
    },
    {
        question: "When is the best time to reserve an affordable cab?",
        answer: "Advance booking generally helps secure better vehicle availability and cost-effective travel options."
    },
    {
        question: "How can customers arrange a cheap cab in Pune?",
        answer: "Bookings can be made through phone calls, WhatsApp inquiries, or online reservations with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Shrikant More",
        feedback:
            "Finding affordable transportation in Pune became much easier after choosing Rising Cab Service. The pricing was reasonable and the travel experience remained comfortable throughout.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Kavita Shinde",
        feedback:
            "A budget-friendly airport transfer exceeded our expectations. The vehicle arrived on time, the journey was smooth, and the overall service offered excellent value.",
        rating: 5
    }
];










    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Cheap Cabs in Pune",
"image": "https://www.risingcabservice.com/assets/images/cheap-cabs-in-pune.jpg",
"description": "Book Cheap Cabs in Pune with Rising Cab Service for budget-friendly local travel, airport transfers, and outstation trips. Enjoy low-cost, economical, and reliable taxi service with safe drivers and comfortable AC cars.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/cheap-cabs-in-pune"
}
};





    return (
        <div>
<Helmet>
  <title>Cheap Cabs in Pune | Budget & Low Fare Taxi Service | +91 9272511548</title>

<meta
 name="description"
 content="Book Cheap Cabs in Pune for budget travel, low-cost rides, airport transfers, and outstation trips. Get economical taxi service with best price, discount offers, and safe AC cabs."
/>

<meta
 name="keywords"
 content="Cheap cabs in pune, budget cab pune, low cost cab pune, affordable cab service pune, cheapest taxi pune, discount cab pune, economy cab pune, low fare taxi pune, cheap outstation cab pune, budget taxi pune, best price cab pune, cab offers pune, economical cab pune, cab deals pune, affordable outstation cab pune, Cheap cab service in pune, Cheap cab service pune, Pune to mumbai cheap cabs, cheapest cab service in Pimpri Chinchwad, Low price taxi service Pimpri Chinchwad, budget cab booking Pune, Cheap outstation cab Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/26.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cheapcabinpune;